import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  listCustomerCreditCards,
  getCustomerCreditCard,
  getCustomerCreditCardDefault,
  addCustomerCreditCard,
  editCustomerCreditCard,
  deleteCustomerCreditCard
} from './api';
import {
  LIST_CUSTOMER_CREDIT_CARDS_REQUEST,
  GET_CUSTOMER_CREDIT_CARD_REQUEST,
  GET_CUSTOMER_CREDIT_CARD_SUCCESS,
  CUSTOMER_CREDIT_CARD_REQUESTING,
  LIST_CUSTOMER_CREDIT_CARDS_SUCCESS,
  RESET_CUSTOMER_CREDIT_CARD_ISFETCHING,
  ADD_CUSTOMER_CREDIT_CARD_REQUEST,
  EDIT_CUSTOMER_CREDIT_CARD_REQUEST,
  DELETE_CUSTOMER_CREDIT_CARD_REQUEST,
  DELETE_CUSTOMER_CREDIT_CARD_SUCCESS
} from './constants';

export function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(listCustomerCreditCards, action.queryString);
    yield put({
      type: LIST_CUSTOMER_CREDIT_CARDS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      getCustomerCreditCard,
      action.customerCreditCardId
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* getDefault() {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(getCustomerCreditCardDefault);
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* add(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      addCustomerCreditCard,
      action.customerCreditCard
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    if (action.successFunction) {
      action.successFunction(response.data);
    }
    return response.data;
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

export function* edit(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      editCustomerCreditCard,
      action.customerCreditCardId,
      action.customerCreditCard
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    if (action.successFunction) {
      action.successFunction(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* deleteObj(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      deleteCustomerCreditCard,
      action.customerCreditCardId
    );
    yield put({
      type: DELETE_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: { id: action.customerCreditCardId }
    });
    if (action.successFunction) {
      action.successFunction(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(LIST_CUSTOMER_CREDIT_CARDS_REQUEST, list);
  yield takeLatest(GET_CUSTOMER_CREDIT_CARD_REQUEST, get);
  yield takeLatest(ADD_CUSTOMER_CREDIT_CARD_REQUEST, add);
  yield takeLatest(EDIT_CUSTOMER_CREDIT_CARD_REQUEST, edit);
  yield takeLatest(DELETE_CUSTOMER_CREDIT_CARD_REQUEST, deleteObj);
}

export default function* customerCreditCardSagas() {
  yield all([watchList()]);
}
